import React, { useState, useEffect } from 'react';

import { Row, Col, Button } from 'react-bootstrap';
import classnames from 'classnames';
import Select from 'components/inputs/Select';
import ButtonList from 'components/inputs/ButtonList';
import DatePicker from 'components/inputs/DatePicker';
import TextInput from 'components/inputs/TextInput';
import { WeekOptions, defaultUsageFilters } from 'constants';
import { subtractTimeFromNow } from 'utils';

import styles from './styles.module.css';

const idPrefix = 'UsageFilters';
const dt1DayAgo = subtractTimeFromNow(1, 'day');

const UsageFilter = (props) => {
  const { onFilterClick, onClear } = props;

  const [selectedOption, setSelectedOption] = useState(
    defaultUsageFilters.option,
  );
  const [selectedWeek, setSelectedWeek] = useState(defaultUsageFilters.week);
  const [startingDt, setStartingDt] = useState(defaultUsageFilters.startingDt);
  const [selectedDay, setSelectedDay] = useState(defaultUsageFilters.noOfDays);
  const [searchText, setSearchText] = useState(defaultUsageFilters.searchText);
  const [daysOption, setDaysOptions] = useState([]);

  useEffect(() => {
    // Calculate the difference in milliseconds
    const today = Date.now();
    const diffTime = Math.abs(today - startingDt);

    // Convert milliseconds to days
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));

    // Calculate days options for select component
    let days = [];
    for (let i = 1; i <= diffDays; i++) {
      days.push({ name: i, value: i });
    }
    setDaysOptions(days);
  }, [startingDt]);

  const filterOptions = [
    {
      name: (
        <div>
          <Select
            idPrefix={`${idPrefix}-week`}
            data-cy-id={`${idPrefix}-FiltersPanel-week`}
            label="Week: "
            options={WeekOptions}
            value={selectedWeek}
            selectClassname={styles.weekInput}
            onChange={({ target: { value } }) => {
              setSelectedOption('week');
              setSelectedWeek(value);
            }}
          />
        </div>
      ),
      value: 'week',
    },
    {
      name: (
        <div className={styles.datecontainer}>
          <div>
            <DatePicker
              idPrefix={`${idPrefix}-FilterPanel-from`}
              value={startingDt}
              label="Starting:"
              onChange={(timestamp) => {
                setSelectedOption('dateRange');
                setStartingDt(timestamp);
              }}
              minPreviousDays={30}
              maxDate={dt1DayAgo}
            />
          </div>
          <span className={styles.filterText}> for </span>
          <div>
            <Select
              idPrefix={`${idPrefix}-month`}
              data-cy-id={`${idPrefix}-FiltersPanel-month`}
              options={daysOption}
              value={selectedDay}
              onChange={({ target: { value } }) => setSelectedDay(value)}
              selectClassname={styles.dayInput}
            />
          </div>
          <span className={styles.filterText}>days</span>
        </div>
      ),
      value: 'dateRange',
    },
  ];

  return (
    <Row className={styles.filterContainer} noGutters>
      <Col className={styles.filterSection}>
        <ButtonList
          key={selectedOption}
          idPrefix="Events-filter"
          name="eventFilters"
          type="radio"
          onChange={(e) => {
            const { value } = e.target;
            setSelectedOption(value);
          }}
          options={filterOptions}
          value={selectedOption}
          arrangementClassName={styles.filterList}
          classname={styles.options}
          testIdPrefix="FlightEventsOverlay"
          noGutters={true}
        />
      </Col>
      <Col className={styles.midSection}>
        <span className={styles.divider} />
        <TextInput
          idPrefix={`${idPrefix}search`}
          label="Title starts with: "
          name="search"
          containerClassName={styles.textContainer}
          labelClassName={styles.textLabel}
          classname={styles.textField}
          value={searchText || ''}
          onChange={({ target: { value } }) => setSearchText(value)}
        />
        <span className={styles.divider} />
      </Col>
      <Col md="auto">
        <Button
          className={classnames('button_reg', styles.button)}
          data-cy-id="Usage-movie-FilterButton"
          onClick={() => {
            setSelectedOption(defaultUsageFilters.option);
            setSelectedWeek(defaultUsageFilters.week);
            setStartingDt(defaultUsageFilters.startingDt);
            setSelectedDay(defaultUsageFilters.noOfDays);
            setSearchText(defaultUsageFilters.searchText);
            onClear(defaultUsageFilters);
          }}
        >
          Clear
        </Button>
        <Button
          className={classnames('button_foc', styles.button)}
          data-cy-id="Usage-movie-FilterButton"
          onClick={() => {
            onFilterClick({
              option: selectedOption,
              week: selectedWeek,
              startingDt: startingDt,
              noOfDays: selectedDay,
              searchText: searchText,
            });
          }}
        >
          Filter
        </Button>
      </Col>
    </Row>
  );
};

export default UsageFilter;
